import { render, staticRenderFns } from "./pt-lab-dna-ready-form.vue?vue&type=template&id=3c8b87a1&"
import script from "./pt-lab-dna-ready-form.vue?vue&type=script&lang=js&"
export * from "./pt-lab-dna-ready-form.vue?vue&type=script&lang=js&"
import style0 from "./pt-lab-dna-ready-form.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports